import { z } from "zod";

import { PAGE_NUMBER_OPTIONS } from "../../../config";

export const LocationActivityQueryParamsSchema = z.object({
  location_id: z.string().optional(),
  locationName: z.string().optional(),
  sort: z.string().optional(),
  order: z.string().optional(),
  limit: z.number(),
  offset: z.number()
});

export type LocationActivityQueryParams = z.infer<
  typeof LocationActivityQueryParamsSchema
>;

export const defaultLocationActivityQueryParams: LocationActivityQueryParams = {
  locationName: "",
  sort: "activity_date",
  order: "desc",
  limit: PAGE_NUMBER_OPTIONS[0],
  offset: 0
};
